// extracted by mini-css-extract-plugin
export default {"table":"Wishes_table__qbMUh","center":"Wishes_center__TaKuU","icon":"Wishes_icon__1xgAl","iconGreen":"Wishes_iconGreen__DWsgU","iconRed":"Wishes_iconRed__rELao"};